module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-60x60-0b5b5130a59b82bff89769f21040b005.png";